<script>
import { mapActions } from 'vuex'
import { setFocus } from '@/services/crud'

export default {
  props: {
    field: {},
    label: {},
    width: {},
    model: {
      type: Object,
      default: () => ({})
    },
    component: {
      type: String,
      required: true
    }
  },
  watch: {
    model () {
      if (this.model && this.model[this.field]) this.escrito = this.model[this.field]
      if (!this.model || !this.model[this.field] || this.model[this.field] === '') this.escrito = ''
      if (this.selecionado) {
        this.fieldFocus()
        this.selecionado = false
      }
    }
  },
  async created () {
    this.modal = await this.newModal({
      component: this.component,
      width: this.width,
      onSave: (data) => {
        this.$emit('change', data)
        this.selecionado = true
      }
    })
  },
  data () {
    return {
      selecionado: false,
      modal: false,
      escrito: ''
    }
  },
  methods: {
    ...mapActions({
      newModal: 'modal/new',
      openModal: 'modal/open',
      destroyModal: 'modal/destroy'
    }),
    clean () {
      this.escrito = ''
    },
    fieldFocus () {
      setFocus('input', this.$refs.field.$el)
    },
    keyDown (e) {
      if (e.event.key === 'Enter') return this.setValueOpen()
    },
    limpaField (e) {
      if (e.element.querySelector('input').value === '') this.$emit('change', {})
    },
    setValueOpen () {
      this.escrito = this.$refs.field.instance.element().querySelector('input').value
      return this.abrir()
    },
    abrir () {
      this.openModal({
        modal: this.modal,
        data: this.escrito
      })
    }
  }
}
</script>

<template>
  <div class="field-busca">
    <div class="label">{{ label }}:</div>
    <dx-text-box ref="field" :show-clear-button="true" placeholder="Digite sua Busca" v-model="escrito" :onInput="limpaField" :onKeyDown="keyDown"></dx-text-box>
    <dx-button icon="find" @click="setValueOpen()" />
  </div>
</template>
